<template>
<!-- v-if="pageId==='11'" -->
	<div   class="function_wrap"   data-type='1'  :style="!isPhone? 'width:1050px;':'width:95%'  ">
            <div :class=" !isPhone? 'function_wrap box':'function_wrap box_mobile' "  :style="'min-height:'+(screenHeight-80)+'px;'">
                <!-- <div class="function_wrap_title">数字大写转换</div> -->
                <h1 class="function_wrap_title">数字大写转换</h1>
                <!-- <div class="function_wrap_title_EN">LEGAL FEES CALCULATOR</div> -->
                
                <!-- <div class='optionitem' >   
                    <div class="optionitem item_name">受理类型：</div>
                  <div  class="optionitem item_detail" >
                        <el-select v-model="index" placeholder="请选择" style="width:100%;" >
                            <el-option
                                v-for="item in kind"
                                :key="item"
                                :value="item">
                            </el-option>
                        </el-select>
                    </div>
                </div>     -->
                <div class='optionitem' >   
                    <div class="optionitem item_name" >输入金额：</div>
                    <div class="optionitem item_detail" > <el-input type='number' min=0 v-model="inputValue" placeholder="请输入金额"></el-input> </div>
                </div>  

         
                <div  style="margin-top:60px">
                  
                    <el-row>
                        <el-button @click="bindcalculate" type="primary">确定</el-button>
                        <el-button @click="resetEvent" type="warning" style="margin-left: 50px;">清空</el-button>
                
                    </el-row>
                </div>


                <div class="result">
                    <h4>转换结果：</h4>
                    <p v-cloak style="margin-top:5px;">&nbsp;&nbsp;&nbsp;&nbsp;{{result}}</p>
                  
                </div>

               
            </div>   


    </div>
</template>

<script>

import { IncUseNumber } from '@/assets/js/cal/cal';  

function isphone() {
	var sUserAgent = navigator.userAgent.toLowerCase();
	var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
	var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
	var bIsMidp = sUserAgent.match(/midp/i) == "midp";
	var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
	var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
	var bIsAndroid = sUserAgent.match(/android/i) == "android";
	var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
	var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
	if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid
			|| bIsCE || bIsWM) {
		return true
	} else {
		return false
	}
}

// var filters = {
//     toFix: function (value) {
//         return value.toFixed(2)//此处2为保留两位小数
//     }
// }  



	export default {
        name: 'legalfee',
        metaInfo: {
            title: '数字大写转换', // set a title
            meta: [{                 // set meta
                name: 'keywords',
                content: '数字大写转换,律师工具,找律师,数字转中文'
            }],
      
        },
        props: {
			isPhone: Boolean
		},
		// placeholder:"hi",
        data() {
			return { 
                // placeholder:"hi",
                // kind: [ '一般财产案件' ,   '离婚无财产案件' ,  '侵害姓名、名称、肖像、名誉、荣誉以及其他人格权案件' , '商标、专利、海商行政案件' , '其他行政案件' ,  '知识产权案件' ,  '申请公示催告' ,  '申请撤销仲裁裁决或认定仲裁裁决效力' ,  '申请破产' ],
                // index:'一般财产案件',
                inputValue:'',
                result:'',

                screenWidth:window.innerWidth,
			    screenHeight:window.innerHeight,
                // halfleft:"halfyes",    
                // halfright: "halfno",
                // half_bg1:'width:60px;height:30px;',
                // half_bg2:"margin-left:120px;width:60px;height:30px; background-color: #dddddd;",
                // ishalf:'1',
                // v_PhoneMode:isphone,
                // isPhone:false
            }

        },
        created(){
            this.isPhone=isphone()
            window.console.log('this.isPhone:',this.isPhone)
        },
        mounted(){
            IncUseNumber('numtrans')
        },
        methods:{
     
  
        resetEvent(){
            this.inputValue='';
            this.result='';
            

        },


        bindcalculate: function () {
            
            this.result=this.convertCurrency(this.inputValue)





        },




        convertCurrency(currencyDigits) {
            var that=this
            // Constants: 
            var MAXIMUM_NUMBER = 99999999999.99;
            // Predefine the radix characters and currency symbols for output: 
            var CN_ZERO = "零";
            var CN_ONE = "壹";
            var CN_TWO = "贰";
            var CN_THREE = "叁";
            var CN_FOUR = "肆";
            var CN_FIVE = "伍";
            var CN_SIX = "陆";
            var CN_SEVEN = "柒";
            var CN_EIGHT = "捌";
            var CN_NINE = "玖";
            var CN_TEN = "拾";
            var CN_HUNDRED = "佰";
            var CN_THOUSAND = "仟";
            var CN_TEN_THOUSAND = "万";
            var CN_HUNDRED_MILLION = "亿";
            var CN_SYMBOL = "";
            var CN_DOLLAR = "元";
            var CN_TEN_CENT = "角";
            var CN_CENT = "分";
            var CN_INTEGER = "整";

            // Variables: 
            var integral;    // Represent integral part of digit number. 
            var decimal;    // Represent decimal part of digit number. 
            var outputCharacters;    // The output result. 
            var parts;
            var digits, radices, bigRadices, decimals;
            var zeroCount;
            var i, p, d, ds;
            var quotient, modulus;

            // Validate input string: 
            currencyDigits = currencyDigits.toString();
            if (currencyDigits == "") {
                that.$message({
                    message: '不能为空 请输入数字金额!如：123.23',
                    type: 'warning'
                });
                // alert("不能为空 请输入数字金额!如：123.23");
                return "";
            }
            if (currencyDigits.match(/[^,.\d]/) != null) {
                // alert("输入字符串中的字符无效!");
                that.$message({
                    message: '输入字符串中的字符无效!',
                    type: 'warning'
                });
                return "";
            }
            if ((currencyDigits).match(/^((\d{1,3}(,\d{3})*(.((\d{3},)*\d{1,3}))?)|(\d+(.\d+)?))$/) == null) {

                that.$message({
                    message: '请输入正确的数字金额!',
                    type: 'warning'
                });
                // alert("请输入正确的数字金额!");
                return "";
            }

            // Normalize the format of input digits: 
            currencyDigits = currencyDigits.replace(/,/g, "");    // Remove comma delimiters. 
            currencyDigits = currencyDigits.replace(/^0+/, "");    // Trim zeros at the beginning. 
            // Assert the number is not greater than the maximum number. 
            if (Number(currencyDigits) > MAXIMUM_NUMBER) {
                // alert("Too large a number to convert!");

                that.$message({
                    message: '数字超出可转换大小!',
                    type: 'warning'
                });
                return "";
            }

            // Process the coversion from currency digits to characters: 
            // Separate integral and decimal parts before processing coversion: 
            parts = currencyDigits.split(".");
            if (parts.length > 1) {
                integral = parts[0];
                decimal = parts[1];
                // Cut down redundant decimal digits that are after the second. 
                decimal = decimal.substr(0, 2);
            }
            else {
                integral = parts[0];
                decimal = "";
            }
            // Prepare the characters corresponding to the digits: 
            digits = new Array(CN_ZERO, CN_ONE, CN_TWO, CN_THREE, CN_FOUR, CN_FIVE, CN_SIX, CN_SEVEN, CN_EIGHT, CN_NINE);
            radices = new Array("", CN_TEN, CN_HUNDRED, CN_THOUSAND);
            bigRadices = new Array("", CN_TEN_THOUSAND, CN_HUNDRED_MILLION);
            decimals = new Array(CN_TEN_CENT, CN_CENT);
            // Start processing: 
            outputCharacters = "";
            // Process integral part if it is larger than 0: 
            if (Number(integral) > 0) {
                zeroCount = 0;
                for (i = 0; i < integral.length; i++) {
                p = integral.length - i - 1;
                d = integral.substr(i, 1);
                quotient = p / 4;
                modulus = p % 4;
                if (d == "0") {
                    zeroCount++;
                }
                else {
                    if (zeroCount > 0) {
                    outputCharacters += digits[0];
                    }
                    zeroCount = 0;
                    outputCharacters += digits[Number(d)] + radices[modulus];
                }
                if (modulus == 0 && zeroCount < 4) {
                    outputCharacters += bigRadices[quotient];
                }
                }
                outputCharacters += CN_DOLLAR;
            }
            // Process decimal part if there is: 
            if (decimal != "") {
                for (i = 0; i < decimal.length; i++) {
                d = decimal.substr(i, 1);
                ds = decimal.substr(-1, 1);
                if (d == 0) {
                    if (ds == 0) {
                    outputCharacters += "";
                    }
                    else {
                    outputCharacters += digits[Number(d)];
                    }
                }
                else {

                    outputCharacters += digits[Number(d)] + decimals[i];

                }
                }
            }
            // Confirm and return the final output string: 
            if (outputCharacters == "") {
                outputCharacters = CN_ZERO + CN_DOLLAR;
            }
            if (decimal == "") {
                outputCharacters += CN_INTEGER;
            }
            outputCharacters = CN_SYMBOL + outputCharacters;
            return outputCharacters;
        } 



    }
    
	}
</script>

<style >
	body
{

    background-color: #f0f0f0;
  
} 
</style>
